import React from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {
    updateChatSoundStatus,
    updateUnreadChatCountAdmin
} from "../../reduxStore/actions/serverConstants";
import SearchPractitioner from "../SearchPractitoner";
import Practitioner from "../../components/practitioner";
import socket from "../../utils/socket";

import {deleteAllChatMessage} from "../../apiRoutes";
import MakeAPICall from "../../apiCalls/common";

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            muteVolume: null,
            chatList: [],
            apiCall: null,
            // allDoctorList: []
        };
    }

    updateVolume = value => {
        this.setState({
            muteVolume: value
        });
        this.props.updateChatSoundStatus(value);
    };

    componentDidMount() {
        // socket.on("doctorMessageDone", this.playAudio); -- removed  it for now
        this.setState({
            muteVolume: this.props.isMuted
        });
    }


    /*
        Search Doc & Nurse API Call after user typing
      */

    // getDoctorList = () => {
    //     let apiCallObj = {
    //         reqType: "GET",
    //         reqUrl: doctorListForChat,
    //         params: {},
    //         successCallback: async res => {
    //             let allDocNurse = res.data.data.doctorData;
    //             // res.data.data.doctorData.concat(
    //             //   res.data.data.nurseData
    //             // );
    //             Sidebar.hasCalledDoctorAndNurseAPI = true;
    //             this.props.updateDoctorAndNurseList(allDocNurse);
    //             // this.setState({
    //             //     allDoctorList: allDocNurse
    //             // });
    //         },
    //         failureCallback: err => {
    //             console.log("Got some error here : ", err);
    //         }
    //     };
    //
    //     this.setState({
    //         apiCall: apiCallObj
    //     });
    // };

    componentWillReceiveProps(newProps, stateProp) {
        if (newProps && newProps.chatList && newProps.chatList.data) {
            this.setState({
                chatList: newProps.chatList.data.data
            });
        }
    }

    openDoctorChat = (event, docData) => {
        event.stopPropagation();
        this.props.openChat(docData);
    };

    openSearchDoctorChat = data => {
        let obj = {
            doctorId: data
        };
        this.props.openChat(obj);
    };

    doctorChatListRead = (event, docData) => {
        event.stopPropagation();
        socket.emit("adminReadChat", {
            chatId: docData._id
        });
    };

    removeAllDocChat = (event, docData) => {
        event.stopPropagation();
        this.doctorChatListRead(event, docData);
        let docId = docData.doctorId._id;
        let apiCallObj = {
            reqType: "POST",
            reqUrl: deleteAllChatMessage,
            dataObj: {
                doctorId: docId
            },
            successCallback: async res => {
                this.props.updateSideChatList();
            },
            failureCallback: err => {
                console.log("Something went wrong, Please try again ! ", err);
            }
        };

        this.setState({
            apiCall: apiCallObj
        });
    };

    render() {
        return (
            <div className="chat-sidebar-container">
                <div className="d-flex flex align-items-center mb-3">
                    <p className="mb-0 mr-3">Support Chat</p>
                    <i
                        onClick={() => this.updateVolume(false)}
                        className={
                            this.props.isMuted === true
                                ? "fas fa-volume-mute speaker-icon"
                                : "hidden"
                        }
                    ></i>
                    <i
                        onClick={() => this.updateVolume(true)}
                        className={
                            this.props.isMuted === false
                                ? "fas fa-volume-up speaker-icon"
                                : "hidden"
                        }
                    ></i>
                </div>
                <SearchPractitioner
                    docList={this.props.doctorAndNurseList}
                    handleOpen={this.openSearchDoctorChat}
                />
                <div className="practitioners-list-container pb-4">
                    {this.state.chatList.map((value, index) => {
                        if (value && (value.doctorId || value.nurseId)) {
                            let name = "";
                            let status = false;

                            if (value && value.doctorId) {
                                name = value.doctorId.firstName + " " + value.doctorId.lastName;
                                status = value.doctorId.visibilityMode;
                            } else {
                                name = value.nurseId.firstName + " " + value.nurseId.lastName;
                                status = value.nurseId.visibilityMode;
                            }

                            return (
                                <Practitioner
                                    key={index}
                                    // status={status}
                                    pracName={name}
                                    pracType={value.doctorId ? "Doctor" : "Nurse"} //guessing for now
                                    messageCount={value.practitionerCount}
                                    showCrossIcon={this.props.user && this.props.user.userType !== "SUPPORT_STAFF"}
                                    userData={value}
                                    handleClick={this.openDoctorChat}
                                    readChatList={this.doctorChatListRead}
                                    removeCompleteDocChat={this.removeAllDocChat}
                                />
                            );
                        }
                    })}
                </div>

                {/* Audio element */}
                {/*<audio className="chat-audio-ele d-none">*/}
                {/*  <source src={DingBell}></source>*/}
                {/*</audio>*/}

                {/* API Call */}
                <MakeAPICall apiParam={this.state.apiCall}/>
            </div>
        );
    }
}

// export default (withRouter(Sidebar));
const mapStateToProps = props => ({
    isMuted: props.serverConstants.isMuted,
    forumUnreadCount: props.serverConstants.forumUnreadCount,
    unreadErxOfflineCount: props.serverConstants.unreadErxOfflineCount,
    tickitCounts: props.serverConstants.tickitCounts,
    supportTickets: props.serverConstants.supportTickets,
    doctorAndNurseList: props.serverConstants.doctorAndNurseList,
    user: props.auth && props.auth.user ? props.auth.user : null,
});

const mapDispatchToProps = dispatch => ({
    updateChatSoundStatus: data => dispatch(updateChatSoundStatus(data)),
    updateUnreadChatCountAdmin: data => dispatch(updateUnreadChatCountAdmin(data))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Sidebar));
